module.exports = __webpack_public_path__ + "static/media/star_off_icon.a5a61c8e.svg";